
export const transmittalRows = [
    {
        sr: "1",
        transmittal: "HIPPL-YYY-PWP-PLA-TML-001",
        type: "Prerequisite",
        docNumber: "HIPPL-ABC-XXX-PLA-PRE-001",
        description: "All Document Submission Tracker",
        totalDocs: "1",
        submissionDate: "30-05-2024",
        ackDate: "11-07-2024",
        submittedFor: "Information",
        feedbackDate: "11-09-2024",
        status: "Approved",
        remark: "",
    },
    {
        sr: "2",
        transmittal: "HIPPL-YYY-PWP-PLA-TML-002",
        type: "Prerequisite",
        docNumber: "HIPPL-ABC-XXX-PLA-PRE-002",
        description: "1. Company Organization Chart 2. Project organization Chart",
        totalDocs: "2",
        submissionDate: "30-05-2024",
        ackDate: "11-07-2024",
        submittedFor: "Information",
        feedbackDate: "11-09-2024",
        status: "Approved",
        remark: "",
    },
    {
        sr: "3",
        transmittal: "HIPPL-YYY-PWP-PLA-TML-003",
        type: "Prerequisite",
        docNumber: "HIPPL-ABC-XXX-PLA-PRE-003",
        description: "1. Communication Matrix 2. Escalation Matrix",
        totalDocs: "2",
        submissionDate: "30-05-2024",
        ackDate: "11-07-2024",
        submittedFor: "Information",
        feedbackDate: "11-09-2024",
        status: "Approved",
        remark: "",
    },
    {
        sr: "4",
        transmittal: "HIPPL-YYY-PWP-PLA-TML-004",
        type: "Prequalification Document Submission",
        docNumber: "HIPPL-ABC-XXX-QUA-PQD-001",
        description: "RMC Plant (Swami raj Concrete Solution)",
        totalDocs: "1",
        submissionDate: "30-05-2024",
        ackDate: "11-07-2024",
        submittedFor: "Approval",
        feedbackDate: "24-07-2024",
        status: "Approved",
        remark: "",
    },
    {
        sr: "5",
        transmittal: "HIPPL-YYY-PWP-PLA-TML-005",
        type: "Prequalification Document Submission",
        docNumber: "HIPPL-ABC-XXX-QUA-PQD-002",
        description: "Third party testing lab Hitech",
        totalDocs: "1",
        submissionDate: "30-05-2024",
        ackDate: "11-07-2024",
        submittedFor: "Approval",
        feedbackDate: "12-07-2024",
        status: "Approved",
        remark: "",
    },
    {
        sr: "6",
        transmittal: "HIPPL-YYY-PWP-PLA-TML-006",
        type: "Prequalification Document Submission",
        docNumber: "HIPPL-ABC-XXX-QUA-PQD-003",
        description: "Third party testing lab Constrovision Engg Consultant Pvt Ltd",
        totalDocs: "1",
        submissionDate: "01-06-2024",
        ackDate: "11-07-2024",
        submittedFor: "Approval",
        feedbackDate: "25-07-2024",
        status: "Reject",
        remark: "",
    },
    {
        sr: "7",
        transmittal: "HIPPL-YYY-PWP-PLA-TML-007",
        type: "Test Report",
        docNumber: "HIPPL-ABC-XXX-QUA-MTR-001",
        description: "Third Party test Report of Plate Load Test (Block E, A14 & A19)",
        totalDocs: "1",
        submissionDate: "06-06-2024",
        ackDate: "11-07-2024",
        submittedFor: "Information",
        feedbackDate: "11-07-2024",
        status: "E",
        remark: "",
    },
    {
        sr: "8",
        transmittal: "HIPPL-YYY-PWP-PLA-TML-008",
        type: "Cocncrete Design Mix Submission",
        docNumber: "HIPPL-ABC-XXX-QUA-DMP-001",
        description: "Design mix submittal for Grades M10,M15,M20,M25,M30,M35 & M40",
        totalDocs: "1",
        submissionDate: "07-06-2024",
        ackDate: "11-07-2024",
        submittedFor: "Approval",
        feedbackDate: "11-07-2024",
        status: "Reject",
        remark: "",
    },
    {
        sr: "9",
        transmittal: "HIPPL-YYY-PWP-PLA-TML-009",
        type: "Legal Documents - HSE",
        docNumber: "HIPPL-ABC-XXX-HSE-LGD-001",
        description: "Workmen Compensation Policy",
        totalDocs: "1",
        submissionDate: "27-06-2024",
        ackDate: "11-07-2024",
        submittedFor: "Information",
        feedbackDate: "11-07-2024",
        status: "E",
        remark: "",
    },
    {
        sr: "10",
        transmittal: "HIPPL-YYY-PWP-PLA-TML-010",
        type: "Work Method Statement",
        docNumber: "HIPPL-ABC-XXX-QUA-WMS-001",
        description: "PCC work",
        totalDocs: "1",
        submissionDate: "08-07-2024",
        ackDate: "11-07-2024",
        submittedFor: "Approval",
        feedbackDate: "24-07-2024",
        status: "Approved",
        remark: "",
    },
    {
        sr: "11",
        transmittal: "HIPPL-YYY-PWP-PLA-TML-011",
        type: "Calibration Certificate",
        docNumber: "HIPPL-ABC-XXX-QUA-CCT-001",
        description: "Lab Equipment Calibration certificate",
        totalDocs: "1",
        submissionDate: "08-07-2024",
        ackDate: "11-07-2024",
        submittedFor: "Information",
        feedbackDate: "24-07-2024",
        status: "E",
        remark: "",
    },
    {
        sr: "12",
        transmittal: "HIPPL-YYY-PWP-PLA-TML-012",
        type: "Material Submittal",
        docNumber: "HIPPL-ABC-XXX-PLA-MAS-001",
        description: "Concrete Cover Block",
        totalDocs: "1",
        submissionDate: "11-07-2024",
        ackDate: "12-07-2024",
        submittedFor: "Approval",
        feedbackDate: "17-08-2024",
        status: "Approved",
        remark: "",
    },
    {
        sr: "13",
        transmittal: "HIPPL-YYY-PWP-PLA-TML-013",
        type: "Material Submittal",
        docNumber: "HIPPL-ABC-XXX-PLA-MAS-002",
        description: "Ultratech Cement OPC-53 Grade",
        totalDocs: "1",
        submissionDate: "11-07-2024",
        ackDate: "12-07-2024",
        submittedFor: "Approval",
        feedbackDate: "17-08-2024",
        status: "Approved",
        remark: "",
    },
    {
        sr: "14",
        transmittal: "HIPPL-YYY-PWP-PLA-TML-014",
        type: "Work Method Statement",
        docNumber: "HIPPL-ABC-XXX-QUA-WMS-002",
        description: "Antitermite Treatment",
        totalDocs: "1",
        submissionDate: "11-07-2024",
        ackDate: "11-07-2024",
        submittedFor: "Approval",
        feedbackDate: "17-08-2024",
        status: "Approved",
        remark: "",
    },
    {
        sr: "15",
        transmittal: "HIPPL-YYY-PWP-PLA-TML-015",
        type: "Material Submittal",
        docNumber: "HIPPL-ABC-XXX-PLA-MAS-003",
        description: "Antitermite Chemical- (Imidacloprid 30.5% SC) -Imida Gold Plus",
        totalDocs: "1",
        submissionDate: "12-07-2024",
        ackDate: "13-07-2024",
        submittedFor: "Approval",
        feedbackDate: "29-08-2024",
        status: "Approved",
        remark: "",
    },
    {
        sr: "16",
        transmittal: "HIPPL-YYY-PWP-PLA-TML-016",
        type: "Test Report",
        docNumber: "HIPPL-ABC-XXX-QUA-MTR-004",
        description: "Construction Water, Soil /Murrum & reinforcement Steel (8mm, 10mm, 12mm, 16mm)",
        totalDocs: "1",
        submissionDate: "12-07-2024",
        ackDate: "13-07-2024",
        submittedFor: "Information",
        feedbackDate: "27-09-2024",
        status: "Approved",
        remark: "",
    },
    {
        sr: "17",
        transmittal: "HIPPL-YYY-PWP-PLA-TML-017",
        type: "Test Report",
        docNumber: "HIPPL-ABC-XXX-QUA-MTR-004",
        description: "Pull out test report for rock anchoring",
        totalDocs: "1",
        submissionDate: "12-07-2024",
        ackDate: "13-07-2024",
        submittedFor: "Information",
        feedbackDate: "11-09-2024",
        status: "E",
        remark: "",
    },
    {
        sr: "18",
        transmittal: "HIPPL-YYY-PWP-PLA-TML-018",
        type: "Advance Bank Guarantee",
        docNumber: "-",
        description: "ABG for block D, E & infra Work",
        totalDocs: "3",
        submissionDate: "16-07-2024",
        ackDate: "16-07-2024",
        submittedFor: "Information",
        feedbackDate: "16-07-2024",
        status: "E",
        remark: "",
    },
    {
        sr: "19",
        transmittal: "HIPPL-YYY-PWP-PLA-TML-019",
        type: "Performance Bank Guarantee",
        docNumber: "-",
        description: "Block D, E & Common Infra Work",
        totalDocs: "3",
        submissionDate: "18-07-2024",
        ackDate: "18-07-2024",
        submittedFor: "Information",
        feedbackDate: "18-07-2024",
        status: "E",
        remark: "",
    },
    {
        sr: "20",
        transmittal: "HIPPL-YYY-PWP-PLA-TML-020",
        type: "Rate Analysis",
        docNumber: "-",
        description: "Soling below foundation at Block-E",
        totalDocs: "1",
        submissionDate: "18-07-2024",
        ackDate: "18-07-2024",
        submittedFor: "Approval",
        feedbackDate: "22-07-2024",
        status: "E",
        remark: "",
    },
    {
        sr: "21",
        transmittal: "HIPPL-YYY-PWP-PLA-TML-021",
        type: "Work Method Statement",
        docNumber: "HIPPL-ABC-XXX-QUA-WMS-003",
        description: "Control Blasting",
        totalDocs: "1",
        submissionDate: "19-07-2024",
        ackDate: "19-07-2024",
        submittedFor: "Approval",
        feedbackDate: "17-08-2024",
        status: "Approved",
        remark: "",
    },
    {
        sr: "22",
        transmittal: "HIPPL-YYY-PWP-PLA-TML-022",
        type: "Cocncrete Design Mix Submission",
        docNumber: "HIPPL-ABC-XXX-QUA-DMP-002",
        description: "Mix Design M35,M35 FF",
        totalDocs: "1",
        submissionDate: "19-07-2024",
        ackDate: "19-07-2024",
        submittedFor: "Information",
        feedbackDate: "13-09-2024",
        status: "E",
        remark: "",
    },
    {
        sr: "23",
        transmittal: "HIPPL-YYY-PWP-PLA-TML-023",
        type: "NCR Closure",
        docNumber: "HIPPL-ABC-XXX-HSE-ENC-001 (Closure)",
        description: "Hard barricading not provided for excavated area.",
        totalDocs: "1",
        submissionDate: "22-07-2024",
        ackDate: "22-07-2024",
        submittedFor: "Approval",
        feedbackDate: "24-07-2024",
        status: "E",
        remark: "",
    },
    {
        sr: "24",
        transmittal: "HIPPL-YYY-PWP-PLA-TML-024",
        type: "Work Method Statement",
        docNumber: "HIPPL-ABC-XXX-QUA-WMS-004",
        description: "Excavation, Backfilling & Soling work (Site wide)",
        totalDocs: "1",
        submissionDate: "24-07-2024",
        ackDate: "24-07-2024",
        submittedFor: "Approval",
        feedbackDate: "21-08-2024",
        status: "Approved",
        remark: "",
    },
    {
        sr: "25",
        transmittal: "HIPPL-YYY-PWP-PLA-TML-025",
        type: "Work Method Statement",
        docNumber: "HIPPL-ABC-XXX-QUA-WMS-005",
        description: "Plum concrete",
        totalDocs: "1",
        submissionDate: "24-07-2024",
        ackDate: "24-07-2024",
        submittedFor: "Approval",
        feedbackDate: "21-08-2024",
        status: "Approved",
        remark: "",
    },
    {
        sr: "26",
        transmittal: "HIPPL-YYY-PWP-PLA-TML-026",
        type: "Material Submittal",
        docNumber: "HIPPL-ABC-XXX-PLA-MAS-004",
        description: "Curing compound ( Brand -Fosroc, Concure WB White)",
        totalDocs: "1",
        submissionDate: "24-07-2024",
        ackDate: "24-07-2024",
        submittedFor: "Approval",
        feedbackDate: "17-08-2024",
        status: "Approved",
        remark: "",
    },
    {
        sr: "27",
        transmittal: "HIPPL-YYY-PWP-PLA-TML-027",
        type: "Material Submittal",
        docNumber: "HIPPL-ABC-XXX-PLA-MAS-005",
        description: "Reinforced steel for RCC work",
        totalDocs: "1",
        submissionDate: "26-07-2024",
        ackDate: "26-07-2024",
        submittedFor: "Approval",
        feedbackDate: "17-08-2024",
        status: "Approved",
        remark: "",
    },
    {
        sr: "28",
        transmittal: "HIPPL-YYY-PWP-PLA-TML-028",
        type: "Material Submittal",
        docNumber: "HIPPL-ABC-XXX-PLA-MAS-006",
        description: "FOSROC Nito bond AR Standard",
        totalDocs: "1",
        submissionDate: "26-07-2024",
        ackDate: "26-07-2024",
        submittedFor: "Approval",
        feedbackDate: "17-08-2024",
        status: "Approved",
        remark: "",
    },
    {
        sr: "29",
        transmittal: "HIPPL-YYY-PWP-PLA-TML-029",
        type: "Material Submittal",
        docNumber: "HIPPL-ABC-XXX-PLA-MAS-007",
        description: "Non Shrink Grout - GP2",
        totalDocs: "1",
        submissionDate: "26-07-2024",
        ackDate: "26-07-2024",
        submittedFor: "Approval",
        feedbackDate: "17-08-2024",
        status: "Approved",
        remark: "",
    },
    {
        sr: "30",
        transmittal: "HIPPL-YYY-PWP-PLA-TML-030",
        type: "Work Method Statement",
        docNumber: "HIPPL-ABC-XXX-QUA-WMS-006",
        description: "RCC Works",
        totalDocs: "1",
        submissionDate: "27-07-2024",
        ackDate: "27-07-2024",
        submittedFor: "Approval",
        feedbackDate: "21-08-2024",
        status: "Approved",
        remark: "",
    },
    {
        sr: "31",
        transmittal: "HIPPL-YYY-PWP-PLA-TML-031",
        type: "Cocncrete Design Mix Submission",
        docNumber: "HIPPL-ABC-XXX-QUA-DMP-001",
        description: "Design mix submittal for Grades M10,M15,M20,M25,M30,M35 & M40 (Rev.01)",
        totalDocs: "1",
        submissionDate: "27-07-2024",
        ackDate: "27-07-2024",
        submittedFor: "Approval",
        feedbackDate: "05-09-2024",
        status: "Approved",
        remark: "",
    },
    {
        sr: "32",
        transmittal: "HIPPL-YYY-PWP-PLA-TML-032",
        type: "Material Submittal",
        docNumber: "HIPPL-ABC-XXX-PLA-MAS-008",
        description: "Admixtures - Super plasticizer- BASF 1126RM",
        totalDocs: "1",
        submissionDate: "27-07-2024",
        ackDate: "27-07-2024",
        submittedFor: "Approval",
        feedbackDate: "17-08-2024",
        status: "Approved",
        remark: "",
    },
    {
        sr: "33",
        transmittal: "HIPPL-YYY-PWP-PLA-TML-033",
        type: "Material Submittal",
        docNumber: "HIPPL-ABC-XXX-PLA-MAS-009",
        description: "Supreme duraboard SD100",
        totalDocs: "1",
        submissionDate: "27-07-2024",
        ackDate: "27-07-2024",
        submittedFor: "Approval",
        feedbackDate: "17-08-2024",
        status: "Approved",
        remark: "",
    },
    {
        sr: "34",
        transmittal: "HIPPL-YYY-PWP-PLA-TML-034",
        type: "Rate Analysis",
        docNumber: "-",
        description: "Filler Board in Expansion Joint",
        totalDocs: "1",
        submissionDate: "29-07-2024",
        ackDate: "29-07-2024",
        submittedFor: "Approval",
        feedbackDate: "01-08-2024",
        status: "Approved",
        remark: "",
    },
    {
        sr: "35",
        transmittal: "HIPPL-YYY-PWP-PLA-TML-035",
        type: "Legal Documents - HSE",
        docNumber: "HIPPL-ABC-XXX-HSE-LGD-001",
        description: "Contractors All Risks insurance Policy",
        totalDocs: "1",
        submissionDate: "31-07-2024",
        ackDate: "31-07-2024",
        submittedFor: "Information",
        feedbackDate: "31-07-2024",
        status: "E",
        remark: "",
    },
    {
        sr: "36",
        transmittal: "HIPPL-YYY-PWP-PLA-TML-036",
        type: "NCR Closure",
        docNumber: "HIPPL-ABC-XXX-QUA-ENC-001 (Closure)",
        description: "Layer wise Backfilling not done",
        totalDocs: "1",
        submissionDate: "31-07-2024",
        ackDate: "31-07-2024",
        submittedFor: "Approval",
        feedbackDate: "05-08-2024",
        status: "E",
        remark: "",
    },
    {
        sr: "37",
        transmittal: "HIPPL-YYY-PWP-PLA-TML-037",
        type: "NCR Closure",
        docNumber: "HIPPL-ABC-XXX-QUA-ENC-002 (Closure)",
        description: "Use of non approved brand for Antitermite Chemical",
        totalDocs: "1",
        submissionDate: "31-07-2024",
        ackDate: "31-07-2024",
        submittedFor: "Approval",
        feedbackDate: "03-08-2024",
        status: "E",
        remark: "",
    },
    {
        sr: "38",
        transmittal: "HIPPL-YYY-PWP-PLA-TML-038",
        type: "NCR Closure",
        docNumber: "HIPPL-ABC-XXX-QUA-ENC-003 (Closure)",
        description: "Backfilling Without WMS",
        totalDocs: "1",
        submissionDate: "31-07-2024",
        ackDate: "31-07-2024",
        submittedFor: "Approval",
        feedbackDate: "05-08-2024",
        status: "E",
        remark: "",
    },
    {
        sr: "39",
        transmittal: "HIPPL-YYY-PWP-PLA-TML-039",
        type: "NCR Closure",
        docNumber: "HIPPL-ABC-XXX-QUA-ENC-005 (Closure)",
        description: "M10 Grade cube not casted.",
        totalDocs: "1",
        submissionDate: "31-07-2024",
        ackDate: "31-07-2024",
        submittedFor: "Approval",
        feedbackDate: "05-08-2024",
        status: "E",
        remark: "",
    },
    {
        sr: "40",
        transmittal: "HIPPL-YYY-PWP-PLA-TML-040",
        type: "Cocncrete Design Mix Submission",
        docNumber: "HIPPL-ABC-XXX-QUA-DMP-003",
        description: "Grades M35 FF",
        totalDocs: "1",
        submissionDate: "31-07-2024",
        ackDate: "31-07-2024",
        submittedFor: "Approval",
        feedbackDate: "07-08-2024",
        status: "Reject",
        remark: "",
    },
    {
        sr: "41",
        transmittal: "HIPPL-YYY-PWP-PLA-TML-041",
        type: "NCR Closure",
        docNumber: "HIPPL-ABC-XXX-PLA-PPL-010",
        description: "Admixtures- (Super plasticizer-SikaPlast PH 8361)",
        totalDocs: "1",
        submissionDate: "31-07-2024",
        ackDate: "31-07-2024",
        submittedFor: "Approval",
        feedbackDate: "17-08-2024",
        status: "Approved",
        remark: "",
    },
    {
        sr: "42",
        transmittal: "HIPPL-YYY-PWP-PLA-TML-042",
        type: "Calibration Certificate",
        docNumber: "HIPPL-ABC-XXX-QUA-CCT-002",
        description: "Calibration Certificate for Digital Thermometer",
        totalDocs: "1",
        submissionDate: "31-07-2024",
        ackDate: "31-07-2024",
        submittedFor: "Information",
        feedbackDate: "14-09-2024",
        status: "E",
        remark: "",
    },
    {
        sr: "43",
        transmittal: "HIPPL-YYY-PWP-PLA-TML-043",
        type: "Test Report",
        docNumber: "HIPPL-ABC-XXX-QUA-MTR-004",
        description: "Mix Design Compressive Strength Reports for grade M10, M15 & M40",
        totalDocs: "1",
        submissionDate: "31-07-2024",
        ackDate: "31-07-2024",
        submittedFor: "Information",
        feedbackDate: "14-09-2024",
        status: "E",
        remark: "",
    },
    {
        sr: "44",
        transmittal: "HIPPL-YYY-PWP-PLA-TML-044",
        type: "Legal Documents - HSE",
        docNumber: "HIPPL-ABC-XXX-HSE-LGD-002",
        description: "1.BOCW-Certificate.-Photocopy 2.Labour Licence-Photocopy 3.Workmen Compensation Policy-Photocopy",
        totalDocs: "3",
        submissionDate: "08-08-2024",
        ackDate: "08-08-2024",
        submittedFor: "Information",
        feedbackDate: "08-08-2024",
        status: "E",
        remark: "",
    },
    {
        sr: "45",
        transmittal: "HIPPL-YYY-PWP-PLA-TML-045",
        type: "NCR Closure",
        docNumber: "HIPPL-ABC-XXX-HSE-ENC-002 (Closure)",
        description: "HSE Documents not filled properly.",
        totalDocs: "1",
        submissionDate: "13-08-2024",
        ackDate: "13-08-2024",
        submittedFor: "Approval",
        feedbackDate: "13-08-2024",
        status: "E",
        remark: "",
    },
    {
        sr: "46",
        transmittal: "HIPPL-YYY-PWP-PLA-TML-046",
        type: "Prequalification Document Submission",
        docNumber: "HIPPL-ABC-XXX-QUA-PQD-004",
        description: "Third party testing lab Constrovision Engg Consultant Pvt Ltd",
        totalDocs: "1",
        submissionDate: "17-08-2024",
        ackDate: "17-08-2024",
        submittedFor: "Approval",
        feedbackDate: "27-09-2024",
        status: "Approved",
        remark: "",
    },
    {
        sr: "47",
        transmittal: "HIPPL-YYY-PWP-PLA-TML-047",
        type: "Mock Up Report",
        docNumber: "HIPPL-ABC-XXX-QUA-MOR-001",
        description: "Mock Up Report for pedestal Shuttering and Bolt Fixing",
        totalDocs: "1",
        submissionDate: "31-08-2024",
        ackDate: "31-08-2024",
        submittedFor: "Approval",
        feedbackDate: "27-09-2024",
        status: "Approved",
        remark: "",
    },
    {
        sr: "48",
        transmittal: "HIPPL-YYY-PWP-PLA-TML-048",
        type: "Prequalification Document Submission",
        docNumber: "HIPPL-ABC-XXX-QUA-PQD-005",
        description: "Mahalaxmi Enterprises RMC Plant",
        totalDocs: "1",
        submissionDate: "03-09-2024",
        ackDate: "03-09-2024",
        submittedFor: "Approval",
        feedbackDate: "27-09-2024",
        status: "Approved",
        remark: "",
    },
    {
        sr: "49",
        transmittal: "HIPPL-YYY-PWP-PLA-TML-049",
        type: "Project Plan",
        docNumber: "HIPPL-ABC-XXX-PLA-PPL-001",
        description: "Project Emergency preparedness and Response Plan",
        totalDocs: "1",
        submissionDate: "04-09-2024",
        ackDate: "04-09-2024",
        submittedFor: "Approval",
        feedbackDate: "04-09-2024",
        status: "Approved",
        remark: "",
    },
    {
        sr: "50",
        transmittal: "HIPPL-YYY-PWP-PLA-TML-050",
        type: "Cocncrete Design Mix Submission",
        docNumber: "HIPPL-ABC-XXX-QUA-DMP-004",
        description: "Grades M35 FF",
        totalDocs: "1",
        submissionDate: "05-09-2024",
        ackDate: "05-09-2024",
        submittedFor: "Approval",
        feedbackDate: "27-09-2024",
        status: "Reject",
        remark: "",
    },
    {
        sr: "51",
        transmittal: "HIPPL-YYY-PWP-PLA-TML-051",
        type: "Work Method Statement",
        docNumber: "HIPPL-ABC-XXX-QUA-WMS-007",
        description: "Sub base preparation, GSB & WMM laying",
        totalDocs: "1",
        submissionDate: "05-09-2024",
        ackDate: "05-09-2024",
        submittedFor: "Approval",
        feedbackDate: "05-10-2024",
        status: "Approved",
        remark: "",
    },
    {
        sr: "52",
        transmittal: "HIPPL-YYY-PWP-PLA-TML-052",
        type: "Test Report",
        docNumber: "HIPPL-ABC-XXX-QUA-MTR-001",
        description: "Plate Load test report at block D",
        totalDocs: "1",
        submissionDate: "16-09-2024",
        ackDate: "16-09-2024",
        submittedFor: "Information",
        feedbackDate: "16-09-2024",
        status: "E",
        remark: "",
    },
    {
        sr: "53",
        transmittal: "HIPPL-YYY-PWP-PLA-TML-053",
        type: "Test Report",
        docNumber: "HIPPL-ABC-XXX-QUA-MTR-002",
        description: "Cube Test Report",
        totalDocs: "1",
        submissionDate: "23-09-2024",
        ackDate: "23-09-2024",
        submittedFor: "Information",
        feedbackDate: "23-09-2024",
        status: "E",
        remark: "",
    },
    {
        sr: "54",
        transmittal: "HIPPL-YYY-PWP-PLA-TML-054",
        type: "Material Submittal",
        docNumber: "HIPPL-ABC-XXX-PLA-MAS-010",
        description: "Lokfix E77",
        totalDocs: "1",
        submissionDate: "27-09-2024",
        ackDate: "27-09-2024",
        submittedFor: "Approval",
        feedbackDate: "05-10-2024",
        status: "Approved",
        remark: "",
    },
    {
        sr: "55",
        transmittal: "HIPPL-YYY-PWP-PLA-TML-055",
        type: "Material Submittal",
        docNumber: "HIPPL-ABC-XXX-PLA-MAS-011",
        description: "PVC Pipe (Supreme Industries Ltd)",
        totalDocs: "1",
        submissionDate: "27-09-2024",
        ackDate: "27-09-2024",
        submittedFor: "Approval",
        feedbackDate: "05-10-2024",
        status: "Approved",
        remark: "",
    },
    {
        sr: "56",
        transmittal: "HIPPL-YYY-PWP-PLA-TML-056",
        type: "Material Submittal",
        docNumber: "HIPPL-ABC-XXX-PLA-MAS-012",
        description: "MS Angle (RINL)",
        totalDocs: "1",
        submissionDate: "28-09-2024",
        ackDate: "28-09-2024",
        submittedFor: "Approval",
        feedbackDate: "05-10-2024",
        status: "Approved",
        remark: "",
    },
    {
        sr: "57",
        transmittal: "HIPPL-YYY-PWP-PLA-TML-057",
        type: "Material Submittal",
        docNumber: "HIPPL-ABC-XXX-PLA-MAS-013",
        description: "Reinforcement Steel (JSW) FE-500 & FE550 D",
        totalDocs: "1",
        submissionDate: "01-10-2024",
        ackDate: "01-10-2024",
        submittedFor: "Approval",
        feedbackDate: "05-10-2024",
        status: "Approved",
        remark: "",
    },
    {
        sr: "58",
        transmittal: "HIPPL-YYY-PWP-PLA-TML-058",
        type: "Project Plan",
        docNumber: "HIPPL-ABC-XXX-PLA-PPL-002",
        description: "Project Logistic Plan",
        totalDocs: "1",
        submissionDate: "07-10-2024",
        ackDate: "08-10-2024",
        submittedFor: "Approval",
        feedbackDate: "08-10-2024",
        status: "Approved",
        remark: "",
    },
    {
        sr: "59",
        transmittal: "HIPPL-YYY-PWP-PLA-TML-059",
        type: "Project Plan",
        docNumber: "HIPPL-ABC-XXX-PLA-PPL-003",
        description: "Construction Waste Management Plan",
        totalDocs: "1",
        submissionDate: "07-10-2024",
        ackDate: "08-10-2024",
        submittedFor: "Approval",
        feedbackDate: "08-10-2024",
        status: "Approved",
        remark: "",
    },
    {
        sr: "60",
        transmittal: "HIPPL-YYY-PWP-PLA-TML-060",
        type: "Project Plan",
        docNumber: "HIPPL-ABC-XXX-PLA-PPL-004",
        description: "Project Plant & Equipment Plan",
        totalDocs: "1",
        submissionDate: "07-10-2024",
        ackDate: "08-10-2024",
        submittedFor: "Approval",
        feedbackDate: "08-10-2024",
        status: "Approved",
        remark: "",
    },
    {
        sr: "61",
        transmittal: "HIPPL-YYY-PWP-PLA-TML-061",
        type: "Project Plan",
        docNumber: "HIPPL-ABC-XXX-PLA-PPL-005",
        description: "Project Natural Calamity, Monsoon Preparedness Plan",
        totalDocs: "1",
        submissionDate: "07-10-2024",
        ackDate: "08-10-2024",
        submittedFor: "Approval",
        feedbackDate: "08-10-2024",
        status: "Approved",
        remark: "",
    },
    {
        sr: "62",
        transmittal: "HIPPL-YYY-PWP-PLA-TML-062",
        type: "NCR Closure",
        docNumber: "HIPPL-ABC-XXX-QUA-ENC-006 (Closure)",
        description: "Foundation Edge found Buldged",
        totalDocs: "1",
        submissionDate: "22-10-2024",
        ackDate: "22-10-2024",
        submittedFor: "Approval",
        feedbackDate: "24-10-2024",
        status: "E",
        remark: "",
    },
    {
        sr: "63",
        transmittal: "HIPPL-YYY-PWP-PLA-TML-063",
        type: "NCR Closure",
        docNumber: "HIPPL-ABC-XXX-QUA-ENC-007 (Closure)",
        description: "Stub Column is Shifted by 10 MM",
        totalDocs: "1",
        submissionDate: "22-10-2024",
        ackDate: "22-10-2024",
        submittedFor: "Approval",
        feedbackDate: "24-10-2024",
        status: "E",
        remark: "",
    },
    {
        sr: "64",
        transmittal: "HIPPL-YYY-PWP-PLA-TML-064",
        type: "NCR Closure",
        docNumber: "HIPPL-ABC-XXX-QUA-ENC-008 (Closure)",
        description: "Retaining Wall east side found buldged",
        totalDocs: "1",
        submissionDate: "22-10-2024",
        ackDate: "22-10-2024",
        submittedFor: "Approval",
        feedbackDate: "24-10-2024",
        status: "E",
        remark: "",
    },
    {
        sr: "65",
        transmittal: "HIPPL-YYY-PWP-PLA-TML-065",
        type: "Project Plan",
        docNumber: "HIPPL-ABC-XXX-PLA-PPL-006",
        description: "Project EHS Plan",
        totalDocs: "1",
        submissionDate: "25-10-2024",
        ackDate: "25-10-2024",
        submittedFor: "Approval",
        feedbackDate: "28-10-2024",
        status: "Approved",
        remark: "",
    },
    {
        sr: "66",
        transmittal: "HIPPL-YYY-PWP-PLA-TML-066",
        type: "Prequalification Document Submission",
        docNumber: "HIPPL-ABC-XXX-QUA-PQD-006",
        description: "Adit RMC Plant",
        totalDocs: "1",
        submissionDate: "14-11-2024",
        ackDate: "14-11-2024",
        submittedFor: "Approval",
        feedbackDate: "19-11-2024",
        status: "Approved",
        remark: "",
    },
    {
        sr: "67",
        transmittal: "HIPPL-YYY-PWP-PLA-TML-067",
        type: "Material Submittal",
        docNumber: "HIPPL-ABC-XXX-PLA-MAS-014",
        description: "GSB & WMM",
        totalDocs: "1",
        submissionDate: "14-11-2024",
        ackDate: "14-11-2024",
        submittedFor: "Approval",
        feedbackDate: "19-11-2024",
        status: "Approved",
        remark: "",
    },
    {
        sr: "68",
        transmittal: "HIPPL-YYY-PWP-PLA-TML-068",
        type: "Test Report",
        docNumber: "HIPPL-ABC-XXX-QUA-MTR-003",
        description: "Plate Load Test at Utility substation and Pump Room",
        totalDocs: "1",
        submissionDate: "14-11-2024",
        ackDate: "14-11-2024",
        submittedFor: "Information",
        feedbackDate: "14-11-2024",
        status: "E",
        remark: "",
    },
    {
        sr: "69",
        transmittal: "HIPPL-YYY-PWP-PLA-TML-069",
        type: "Test Report",
        docNumber: "HIPPL-ABC-XXX-QUA-MTR-004",
        description: "Company Name & Legal Identity change of Hitech Lab",
        totalDocs: "1",
        submissionDate: "19-11-2024",
        ackDate: "19-11-2024",
        submittedFor: "Information",
        feedbackDate: "19-11-2024",
        status: "E",
        remark: "",
    },
    {
        sr: "70",
        transmittal: "HIPPL-YYY-PWP-PLA-TML-070",
        type: "Material Submittal",
        docNumber: "HIPPL-ABC-XXX-PLA-MAS-015",
        description: "Sika Grout 214 IN S for concrete repair & Grouting work",
        totalDocs: "1",
        submissionDate: "16-12-2024",
        ackDate: "16-12-2024",
        submittedFor: "Approval",
        feedbackDate: "19-12-2024",
        status: "Approved",
        remark: "",
    },
    {
        sr: "71",
        transmittal: "HIPPL-YYY-PWP-PLA-TML-071",
        type: "Material Submittal",
        docNumber: "HIPPL-ABC-XXX-PLA-MAS-016",
        description: "Fly ash bricks",
        totalDocs: "1",
        submissionDate: "16-12-2024",
        ackDate: "16-12-2024",
        submittedFor: "Approval",
        feedbackDate: "19-12-2024",
        status: "Approved",
        remark: "",
    },
    {
        sr: "72",
        transmittal: "HIPPL-YYY-PWP-PLA-TML-072",
        type: "Work Method Statement",
        docNumber: "HIPPL-ABC-XXX-QUA-WMS-008",
        description: "Anchor Bolt Instalaltion",
        totalDocs: "1",
        submissionDate: "16-12-2024",
        ackDate: "16-12-2024",
        submittedFor: "Approval",
        feedbackDate: "19-12-2024",
        status: "Approved",
        remark: "",
    },
    {
        sr: "73",
        transmittal: "HIPPL-YYY-PWP-PLA-TML-073",
        type: "Work Method Statement",
        docNumber: "HIPPL-ABC-XXX-QUA-WMS-009",
        description: "Brick work",
        totalDocs: "1",
        submissionDate: "16-12-2024",
        ackDate: "16-12-2024",
        submittedFor: "Approval",
        feedbackDate: "19-12-2024",
        status: "Approved",
        remark: "",
    },
    {
        sr: "74",
        transmittal: "HIPPL-YYY-PWP-PLA-TML-074",
        type: "Work Method Statement",
        docNumber: "HIPPL-ABC-XXX-QUA-WMS-010",
        description: "Rock anchoring work",
        totalDocs: "1",
        submissionDate: "16-12-2024",
        ackDate: "16-12-2024",
        submittedFor: "Approval",
        feedbackDate: "04-01-2025",
        status: "Approved",
        remark: "",
    },
    {
        sr: "75",
        transmittal: "HIPPL-YYY-PWP-PLA-TML-075",
        type: "Material Submittal",
        docNumber: "HIPPL-ABC-XXX-PLA-MAS-017",
        description: "Reinforcement steel (CRS) for Rock anchoring work (Site wide)",
        totalDocs: "1",
        submissionDate: "30-12-2024",
        ackDate: "30-12-2024",
        submittedFor: "Approval",
        feedbackDate: "04-01-2025",
        status: "Approved",
        remark: "",
    },
    {
        sr: "76",
        transmittal: "HIPPL-YYY-PWP-PLA-TML-076",
        type: "Material Submittal",
        docNumber: "HIPPL-ABC-XXX-PLA-MAS-018",
        description: "uPVC Pipe & Sockets for Sewer line purpose ( Site wide)",
        totalDocs: "1",
        submissionDate: "30-12-2024",
        ackDate: "30-12-2024",
        submittedFor: "Approval",
        feedbackDate: "04-01-2025",
        status: "Approved",
        remark: "",
    },
    {
        sr: "77",
        transmittal: "HIPPL-YYY-PWP-PLA-TML-077",
        type: "Work Method Statement",
        docNumber: "HIPPL-ABC-XXX-QUA-WMS-011",
        description: "Non Shrink Grouting between PEB & RCC Pendestral work (Site wide)",
        totalDocs: "1",
        submissionDate: "02-01-2025",
        ackDate: "02-01-2025",
        submittedFor: "Approval",
        feedbackDate: "04-01-2025",
        status: "Approved",
        remark: "",
    },
];
